import { render, staticRenderFns } from "./institutionManage.vue?vue&type=template&id=4d08183c&scoped=true&"
import script from "./institutionManage.vue?vue&type=script&lang=js&"
export * from "./institutionManage.vue?vue&type=script&lang=js&"
import style0 from "./institutionManage.vue?vue&type=style&index=0&id=4d08183c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d08183c",
  null
  
)

export default component.exports